import type { CSSProperties } from 'react';

/**
 * Dark-theme Recharts Tooltip styling shared across Quality · Dynamics charts
 * (matches MTTR dynamics: surface, border, label legibility, crosshair).
 */
export const DYNAMICS_RECHARTS_TOOLTIP_CURSOR = {
  stroke: 'rgba(148, 163, 184, 0.35)',
  strokeWidth: 1,
} as const;

export const DYNAMICS_RECHARTS_TOOLTIP_CONTENT_STYLE: CSSProperties = {
  backgroundColor: 'var(--color-surface-elevated, #1e293b)',
  border: '1px solid var(--color-border, rgba(148, 163, 184, 0.4))',
  borderRadius: 8,
  padding: '10px 12px',
  boxShadow: '0 12px 36px rgba(0, 0, 0, 0.45)',
};

export const DYNAMICS_RECHARTS_TOOLTIP_LABEL_STYLE: CSSProperties = {
  color: 'var(--color-text, #e2e8f0)',
  fontWeight: 600,
  fontSize: '0.8rem',
  marginBottom: 6,
};

export const DYNAMICS_RECHARTS_TOOLTIP_ITEM_STYLE: CSSProperties = {
  paddingTop: 3,
  paddingBottom: 3,
  fontSize: '0.78rem',
};

/** Spread onto `<Tooltip />` together with chart-specific `formatter` / `content` when needed. */
export const DYNAMICS_RECHARTS_TOOLTIP_COMMON = {
  cursor: DYNAMICS_RECHARTS_TOOLTIP_CURSOR,
  contentStyle: DYNAMICS_RECHARTS_TOOLTIP_CONTENT_STYLE,
  labelStyle: DYNAMICS_RECHARTS_TOOLTIP_LABEL_STYLE,
  itemStyle: DYNAMICS_RECHARTS_TOOLTIP_ITEM_STYLE,
} as const;
